import type { PillarsContent } from "../types";

export const pillars: PillarsContent = {
  title: "Platformen, som dansk forskning <br>allerede kører på.",
  pillars: [
    {
      metric: "25k",
      label: "Forskere og studerende",
      statement:
        "Én national platform, ét login, alle otte danske universiteter. Europas mest anvendte nationale forskningssky målt på brugere.",
      link: "Se hvordan det virker",
    },
    {
      metric: "0",
      label: "Tokens der forlader Danmark",
      statement:
        "Hver forespørgsel behandles på dansk jord, under dansk lov. Dine data forbliver i Danmark og bruges aldrig til modeltræning.",
      link: "Læs datapolitikken",
    },
    {
      metric: "100%",
      label: "Åben, inspicerbar kode",
      statement:
        "Open source under EUPL-licensen og ISO/IEC 27001:2022-certificeret, ni års offentlig udvikling. Suverænitet bygges på tillid, og tillid kræver gennemsigtighed.",
      link: "Læs kildekoden",
    },
  ],
};
